import React, { useEffect, useState } from 'react';

import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { GlobalLoader } from '@liscio/ui';

import { SELF_SIGNUP_INVITATION_TOKEN_KEY } from './constants';
import { LazyWrapper } from 'components';
import { config } from 'config';

const SignupView = React.lazy(
  () => import('./views/SignupView/SignupView')
);

export const SelfSignupRoute = () => {
  const ldEnabled = config.launchDarkly.isEnabled;
  const ldClient = useLDClient();
  const { selfSignupMode } = useFlags();
  const location = useLocation();
  const { invitationToken } = useParams<{ invitationToken?: string }>();
  const [ldReady, setLdReady] = useState(!ldEnabled);

  useEffect(() => {
    if (!ldEnabled || !ldClient) return undefined;

    let active = true;
    void ldClient.waitUntilReady().then(() => {
      if (active) setLdReady(true);
    });

    return () => {
      active = false;
    };
  }, [ldEnabled, ldClient]);

  if (ldEnabled && !ldReady) return <GlobalLoader open />;
  const mode = typeof selfSignupMode === 'string' ? selfSignupMode : 'disabled';

  if (!['disabled', 'invite_only', 'open'].includes(mode)) {
    return <Navigate to="/authenticate/login" replace />;
  }

  if (mode === 'disabled') {
    return <Navigate to="/authenticate/login" replace />;
  }

  const isBareSignup = ['/signup', '/self-signup'].includes(location.pathname);
  const hasStoredInvitation = Boolean(
    sessionStorage.getItem(SELF_SIGNUP_INVITATION_TOKEN_KEY)
  );
  const inviteRequired = mode === 'invite_only' && isBareSignup && !invitationToken && !hasStoredInvitation;

  return (
    <LazyWrapper>
      <SignupView selfSignupMode={mode as 'invite_only' | 'open'} inviteRequired={inviteRequired} />
    </LazyWrapper>
  );
};

export default SelfSignupRoute;
